import request from '@/utils/request'


export function addOrUpdateBorderlessPanel(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/addOrUpdateBorderlessPanel`,
        method: 'post',
        data,
    })
}


export function selectBorderlessPanel(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/BorderlessSet/selectBorderlessPanel?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteBorderlessPanel(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/bathDeleteBorderlessPanel`,
        method: 'post',
        data,
    })
}



export function selectBorderlessCarvingName(data) {
    return request({
        url: `api/serviceCenter/borderlessCarvingSet/selectBorderlessCarvingName?access=${data}`,
        method: 'post',
    })
}

export function addOrUpdateBorderlessFloor(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/addOrUpdateBorderlessFloor`,
        method: 'post',
        data,
    })
}


export function selectBorderlessFloor(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/BorderlessSet/selectBorderlessFloor?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteBorderlessFloor(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/bathDeleteBorderlessFloor`,
        method: 'post',
        data,
    })
}


export function addOrUpdateBorderlessSideband(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/addOrUpdateBorderlessSideband`,
        method: 'post',
        data,
    })
}


export function selectBorderlessSideband(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/BorderlessSet/selectBorderlessSideband?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteBorderlessSideband(data) {
    return request({
        url: `api/serviceCenter/BorderlessSet/bathDeleteBorderlessSideband`,
        method: 'post',
        data,
    })
}
